module.exports = __webpack_public_path__ + "static/media/nd6.a5535d85.webp";